/* ===== Store-Audit (POUR HAPPINESS) – laeuft ZUERST, unabhaengig von jQuery ===== */
/* leere "No image"-Platzhalter (Trust-Badges/Icons) sofort per CSS ausblenden */
/* + Social-Proof-Widget (Fake-Zahlen) auf der Produktseite ausblenden (Anna, 03.09.2026) */
(function () {
  var css = '.svg-icon:has(img[src*="no-image"]){display:none!important;}'
          + '.svg-icon img[src*="no-image"]{display:none!important;}'
          + '[class*="ai-olive-blog-section-"]{display:none!important;}'
          + '.social-banner{display:none!important;}'
          + '.review-badge{display:none!important;}';
  var s = document.createElement('style');
  s.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(s);
})();

/* #8: Sterne/Bewertung klickbar -> zu den Reviews scrollen; #12: kaputtes UGC-Bild ausblenden */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".review-badge, .rating, .product-reviews-dummy").forEach(function (el) {
    el.style.cursor = "pointer";
    el.addEventListener("click", function (e) {
      var target = document.querySelector(".jdgm-reviews-grid-widget, .jdgm-all-reviews-widget, .jdgm-widget");
      if (target) { e.preventDefault(); (target.closest('[id^="shopify-section"]') || target).scrollIntoView({ behavior: "smooth", block: "start" }); }
    });
  });
  function hideBrokenUgc() {
    document.querySelectorAll('img[class*="ai-ugc-rail"]').forEach(function (im) {
      if (im.complete && im.naturalWidth === 0) { (im.closest('li, [class*="slide"], [class*="item"], a') || im).style.display = "none"; }
    });
  }
  hideBrokenUgc();
  window.addEventListener("load", hideBrokenUgc);
  setTimeout(hideBrokenUgc, 1500);
});

/* Produktseite: Positionierungs-Satz direkt unter dem Titel (StoryBrand) */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  function injectPos() {
    var title = document.querySelector(".product__title");
    if (!title || document.querySelector(".ph-pos-line")) return;
    var d = document.createElement("div");
    d.className = "ph-pos-line";
    d.style.cssText = "margin:.4rem 0 1rem;";
    d.innerHTML = '<p style="font-size:1.7rem;font-weight:700;color:#1f4d34;margin:0 0 .2rem;line-height:1.25;">Das EINE Olivenöl für deine Küche.</p><p style="font-size:1.4rem;color:#555;margin:0;">Zum Kochen, Braten, Dippen &amp; Drizzlen.</p>';
    title.insertAdjacentElement("afterend", d);
  }
  document.addEventListener("DOMContentLoaded", injectPos);
  window.addEventListener("load", injectPos);
  setTimeout(injectPos, 900);
})();

/* Produktseite: Steuer-/Versandzeile vereinheitlichen zu "Inklusive MwSt." – Versandhinweis raus, DE + EN (Anna, 03.09.2026) */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  function fixTax() {
    document.querySelectorAll('.product__tax, small.tax-note').forEach(function (el) {
      if (el.dataset.phTaxFixed) return;
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!t) return;
      // erkennt die Steuer-/Versandzeile in Deutsch UND Englisch
      if (/Checkout berechnet|calculated at checkout|Tax included|Inklusive|inkl\.|Steuer|Versand|Shipping/i.test(t)) {
        el.textContent = 'Inklusive MwSt.';
        el.dataset.phTaxFixed = '1';
      }
    });
  }
  document.addEventListener("DOMContentLoaded", fixTax);
  window.addEventListener("load", fixTax);
  setTimeout(fixTax, 700);
  setTimeout(fixTax, 1600);
  document.addEventListener("change", function () { setTimeout(fixTax, 400); }, true);
})();

/* Produktseite: "immer kostenloser Versand" USP -> "Kostenloser Versand ab 20 €" (Anna, 17.09.2026) */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  function fixUsp() {
    var els = document.querySelectorAll('body *');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length === 0 && el.textContent && /immer\s+kostenlose?r?\s+Versand/i.test(el.textContent)) {
        el.textContent = "\uD83D\uDE9B Kostenloser Versand ab 20 \u20AC";
      }
    }
  }
  document.addEventListener("DOMContentLoaded", fixUsp);
  window.addEventListener("load", fixUsp);
  setTimeout(fixUsp, 900);
  setTimeout(fixUsp, 1800);
})();

/* ===== Original-Theme-Code (jQuery) – unveraendert ===== */
(function phInitJQ(){ if(!window.jQuery){ return setTimeout(phInitJQ,50); } jQuery( document ).ready(function($) {
     $('.list-menu__item span').click(function(){
       $(this).closest('.list-menu__item').toggleClass('active_item');
    })


  $('.annouce-slider').flickity({
  contain: true,
  pageDots: false,
prevNextButtons: false,
    autoPlay: 5000 ,
    wrapAround: true
});
  var $backToTop = $(".back-to-top");
  $backToTop.hide();

  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
      $backToTop.fadeIn();
    } else {
      $backToTop.fadeOut();
    }
  });

  $backToTop.on('click', function(e) {
    $("html, body").animate({scrollTop: 0}, 500);
  });

  $('.product-grid-container').addClass('grid-view-section');
    // Toggle between grid and list view
    $('.grid-view').click(function() {
        $(this).addClass('active');
        $('.list-view').removeClass('active');
        $('.product-grid-container').removeClass('list-view-section1').addClass('grid-view-section');
        $('#product-grid').removeClass('grid--4-col-desktop grid--2-col-tablet-down').addClass('grid--2-col-desktop grid--1-col-tablet-down');
    });

    $('.list-view').click(function() {
        $(this).addClass('active');
        $('.grid-view').removeClass('active');
        $('.product-grid-container').removeClass('grid-view-section1').addClass('list-view-section1');
        $('#product-grid').removeClass('grid--2-col-desktop grid--1-col-tablet-down').addClass('grid--4-col-desktop grid--2-col-tablet-down');

    });
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  const stickyForm = document.querySelector("product-sticky-form");
  const footer = document.querySelector("footer");

  if (stickyForm && footer) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyForm.style.display = "none";
          } else {
            stickyForm.style.display = "";
          }
        });
      },
      {
        root: null,
        threshold: 0,
      }
    );

    observer.observe(footer);
  }
});
